const RouteConfig = {
  home: '/',
  details: '/details',
  schedule: '/schedule',
};

export default RouteConfig;
